import { Text } from '@chakra-ui/react'

import type { PremiumDelta } from '@/dtos/exceptionalDiscount'
import { fmtKc, fmtPctChip } from '../lib/premiumMath'

export const DiffChip = ({ delta }: { delta?: PremiumDelta | null }) => {
  if (!delta || Math.abs(delta.amountKc) < 0.5) {
    return (
      <Text
        as="span"
        px={2}
        py={0.5}
        bg="gray.100"
        color="gray.400"
        borderRadius="full"
        fontSize="xs"
        fontWeight="bold"
        title="Beze změny"
      >
        –
      </Text>
    )
  }

  const up = delta.amountKc > 0

  return (
    <Text
      as="span"
      px={2}
      py={0.5}
      bg={up ? 'orange.100' : 'green.100'}
      color={up ? 'orange.800' : 'green.800'}
      borderRadius="full"
      fontSize="xs"
      fontWeight="bold"
      whiteSpace="nowrap"
    >
      {`${up ? '+' : '−'} ${fmtKc(Math.abs(delta.amountKc))} · ${fmtPctChip(delta.percent)}`}
    </Text>
  )
}
